<template>
  <v-container fluid>
    <loader v-if="loading"></loader>

    <v-container v-if="!loading">

    <v-container fluid >
      <v-card style="margin:auto;" width="40%">
        <v-flex  pl-4 pr-4 text-xs-right>
          <v-select
          label="search" 
          append-icon="search"
          disabled></v-select>
        </v-flex>
      </v-card>
    </v-container>
    <v-layout row wrap>
      <v-flex xs12 v-if="points[0]===undefined">
        <v-card class="mt-5" width="50%" style="margin:auto">
          <v-card-title class="headline">
            No Data Available
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 sm4 md4 v-for="(point, i) in points" v-bind:key="i">
        <v-card xs12 color="grey lighten-3" class=" mb-3  ma-3">
          <v-container fluid>
            <v-card-title>
              <div><h3> Title of Spot: {{point.title}}</h3>
                
                <p>Point Id: {{point.id}} 
                  <br> </p>
                <div style="text-align: right;">

                </div>
              </div>
            </v-card-title>
            <v-card-media style="border:solid;" src="http://www.alfavita.gr/sites/default/files/styles/imagearthron/public/0014-16-sx04.jpg"  height="200px" :alt="'pic.infoPicture'"></v-card-media>
            <v-flex>
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex xs6 class="text-xs-left">
                    <v-btn medium color="indigo" style="color:orange;" @click="previewSpot(point.id)">
                      Preview
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 class="text-xs-right">
                    <v-btn medium color="red lighten-1" style="color:white;" @click="loadSpot(point.id)">
                      Edit
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 class="text-xs-center">

                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>


          </v-container>


        </v-card>
      </v-flex>



    </v-layout>
<add-spot id="float"></add-spot>

</v-container>
  </v-container>




</template>

<script>
  export default {
    data() {
      return {

      }
    },
    mounted: function () {
      this.$store.dispatch("getPoints");
    },

    computed: {
      points() {
        return this.$store.getters.points;
      },
      maxSpotId(){
        return this.$store.getters.maxSpotId;
      },
      loading(){
        return this.$store.getters.loading;
      }
    },

    watch: {

    },
    methods: {
      loadSpot(id){
        this.$router.push("/spot/"+id);
      },
       previewSpot(id){
        this.$store.dispatch('loadSpotContent', id);
        this.$router.push("/spot/"+id+"/preview");
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  #float{
  position: fixed;
 bottom: 5%;
  right:1%;
  }

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue